import { render } from "./CommonCalendarEventRouterView.vue?vue&type=template&id=4cc60ef2"
import script from "./CommonCalendarEventRouterView.vue?vue&type=script&lang=ts"
export * from "./CommonCalendarEventRouterView.vue?vue&type=script&lang=ts"
script.render = render

export default script